import * as React from 'react';
import { InlineText2 } from '@cian/ui-kit';
import { IconMapWalk16, IconMapBus16 } from '@cian/ui-kit-design-tokens/icons';
import { pluralize } from '@cian/newbuilding-utils';

interface IFromUndergroundProps {
  timeTransport?: number | null;
  timeWalk?: number | null;
}

export const FromUndergroundTime: React.FC<IFromUndergroundProps> = props => {
  const { timeTransport, timeWalk } = props;

  if (timeWalk && timeWalk <= 20) {
    return (
      <>
        <div style={{ lineHeight: '12px' }}>
          <IconMapWalk16 color={'icon-secondary-default'} />
        </div>
        <InlineText2 color={'black_60'}>{pluralize(timeWalk, ['минута', 'минуты', 'минут'])}</InlineText2>
      </>
    );
  }
  if (timeTransport) {
    return (
      <>
        <div style={{ marginRight: '4px', lineHeight: '12px' }}>
          <IconMapBus16 color={'icon-secondary-default'} />
        </div>
        <InlineText2 color={'black_60'}>{pluralize(timeTransport, ['минута', 'минуты', 'минут'])}</InlineText2>
      </>
    );
  }

  return null;
};
